import { replica } from '@/shared/sync/replica';
import { type AccessRequest, accessRequestSchema } from '../schemas/access-request';

export async function listAccessRequests(): Promise<AccessRequest[]> {
  return accessRequestSchema.array().parse(await replica.http.json<unknown>('/access/requests'));
}
